export const AUTH_ROUTES = {
  SIGN_IN: "/sign-in",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
} as const;

export const PROTECTED_ROUTES = {
  DASHBOARD: "/dashboard",
  GAMIFICATION: "/gamification",
  GAMIFICATION_CHALLENGES: "/gamification/challenges",
  GAMIFICATION_RANKING: "/gamification/ranking",
  STAFF: "/staff",
  STAFF_NEW: "/staff/new",
  ATHLETES: "/athletes",
  ATHLETE_DETAIL: "/athletes/$athleteId",
  ATHLETE_NEW: "/athletes/new",
  ATHLETE_WORKOUT_PLAN_NEW: "/athletes/$athleteId/workout-plans/new",
  ATHLETE_WORKOUT_PLAN_EDIT:
    "/athletes/$athleteId/workout-plans/$workoutPlanId/edit",
  ATHLETE_WORKOUT_BLOCK_NEW: "/athletes/$athleteId/workout-blocks/new",
  ATHLETE_WORKOUT_BLOCK_DETAIL:
    "/athletes/$athleteId/workout-blocks/$workoutBlockId",
  ATHLETE_WORKOUT_BLOCK_EDIT:
    "/athletes/$athleteId/workout-blocks/$workoutBlockId/edit",
  CALENDAR: "/scheduling",
  GYM_SCHEDULES: "/scheduling/schedules",
  GYM_SCHEDULE_EDIT: "/scheduling/schedules/$scheduleId",
  GYM_SCHEDULE_BLUEPRINT_EDIT: "/scheduling/schedules/$scheduleId/edit",
  CALENDAR_DETAIL: "/scheduling/$eventId",
  CALENDAR_NEW_EVENT: "/scheduling/events/new",
  CALENDAR_EDIT_EVENT: "/scheduling/$eventId/edit",
  LOGISTIC: "/logistic",
  LOGISTIC_DISCIPLINES: "/logistic/disciplines",
  LOGISTIC_EXERCISES: "/logistic/exercises",
  LOGISTIC_ROOMS: "/logistic/rooms",
  LOGISTIC_NEW_ROOM: "/logistic/rooms/new",
  LOGISTIC_ROOMS_DETAIL: "/logistic/rooms/$roomId",
} as const;

export const MANAGEMENT_ROUTES = {
  MANAGEMENT_DASHBOARD: "/management/dashboard",
  DISCIPLINES: "/management/disciplines",
  DISCIPLINE_DETAIL: "/management/disciplines/$disciplineId",
  NEW_DISCIPLINE: "/management/disciplines/new",
  EXERCISES: "/management/exercises",
  EXERCISE_DETAIL: "/management/exercises/$exerciseId",
  NEW_EXERCISE: "/management/exercises/new",
} as const;

export const ROOT_ROUTES = {
  HOME: "/",
} as const;

export const ROUTES = {
  ...AUTH_ROUTES,
  ...PROTECTED_ROUTES,
  ...MANAGEMENT_ROUTES,
  ...ROOT_ROUTES,
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

export const buildRoute = {
  gymScheduleEdit: (scheduleId: number) =>
    `/scheduling/schedules/${scheduleId}`,
  gymScheduleBlueprintEdit: (scheduleId: number) =>
    `/scheduling/schedules/${scheduleId}/edit`,
  staffProfile: (id: number) => `/staff/${id}`,
  athleteWorkoutPlanNew: (athleteId: number) =>
    `/athletes/${athleteId}/workout-plans/new`,
  disciplineDetail: (disciplineId: string) =>
    `/management/disciplines/${disciplineId}`,
  roomDetail: (roomId: string) => `/logistic/rooms/${roomId}`,
  exerciseDetail: (exerciseId: string) => `/management/exercises/${exerciseId}`,
} as const;

export type ScheduleReturnRoute =
  | { to: string; search: { tab: "calendar"; week: string | undefined } }
  | {
      to: typeof PROTECTED_ROUTES.CALENDAR;
      search: { week: string | undefined };
    };

export function buildScheduleReturnRoute(
  staffProfileId: number | undefined,
  week: string | undefined,
): ScheduleReturnRoute {
  if (staffProfileId !== undefined) {
    return {
      to: buildRoute.staffProfile(staffProfileId),
      search: { tab: "calendar", week },
    };
  }
  return { to: PROTECTED_ROUTES.CALENDAR, search: { week } };
}

export function resolveScheduleReturnStaffMemberId(
  contextStaffMemberId: number | undefined,
  formStaffMemberId: number | undefined,
): number | undefined {
  if (contextStaffMemberId === undefined) return undefined;
  return formStaffMemberId ?? contextStaffMemberId;
}
